import { IColumn } from '@features/General'
export const listColumns = (i18n): IColumn[] => [
    {
        title: '',
        key: 'avatar',
        type: 'avatar',
        fallbackTextColumns: ['firstname', 'lastname'],
        preview: true
    },
    {
        title: i18n?.Matching?.Contact_Name,
        key: 'contactName',
        fields: ['firstname', 'lastname']
    },
    {
        title: i18n?.TradeHub?.Jon_Position,
        key: 'jobTitle'
    }
]
